import { useEffect, useState } from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from '@heroui/react';
import type { FamiliaProducto } from '@/types/familia-producto.model';

interface DeleteFamiliaProductoModalProps {
  isOpen: boolean;
  onClose: () => void;
  onDelete: (id: string | number) => Promise<void>;
  familiaProducto?: FamiliaProducto;
}

const DeleteFamiliaProductoModal = ({ isOpen, onClose, onDelete, familiaProducto }: DeleteFamiliaProductoModalProps) => {
  const [itemToDelete, setItemToDelete] = useState<FamiliaProducto | undefined>(undefined);

  // Populate form when familiaProducto changes
  useEffect(() => {
    if (familiaProducto) {
      setItemToDelete(familiaProducto);
    } else {
      setItemToDelete(undefined);
    }
  }, [familiaProducto]);

  const handleDelete = async () => {
    if (itemToDelete?.id) {
      await onDelete(itemToDelete.id);
      onClose();
    }
  };

  return (
    <Modal 
      isOpen={isOpen} 
      onClose={onClose}
      placement="top-center"
      backdrop="blur"
    >
      <ModalContent>
        {(onClose) => (
          <>
            <ModalHeader className="flex flex-col gap-1">Eliminar Familia de Producto</ModalHeader>
            <ModalBody>
              <p>¿Estás seguro de que deseas eliminar la familia de producto <strong>{itemToDelete?.nombre}</strong>?</p>
              <p className="text-danger">Esta acción no se puede deshacer.</p>
            </ModalBody>
            <ModalFooter>
              <Button 
                color="danger" 
                variant="light" 
                onPress={onClose}
              >
                Cancelar
              </Button>
              <Button 
                color="primary" 
                onPress={handleDelete}
              >
                Eliminar
              </Button>
            </ModalFooter>
          </>
        )}
      </ModalContent>
    </Modal>
  );
};

export default DeleteFamiliaProductoModal;